
import { defineComponent } from 'vue'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingAlertPastDue',
  props: {
    planName: {
      type: String,
      default: ''
    },
    // Nullable: upcomingPaymentDate can be absent (e.g. the backend nulls it for
    // past-due / scheduled-cancel subs), so the banner must degrade without a date.
    dueDate: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedDueDate(): string | null {
      if (!this.dueDate) return null
      const date = parseISODate(this.dueDate)
      if (isNaN(date.getTime())) return null
      return formatDate(date)
    }
  }
})
